module.exports = __webpack_public_path__ + "static/img/logo.f861e1ac.svg";